// How long to wait before saving the assignment data to the database.
export const ASSIGNMENT_DATA_DEBOUNCE_MS = 600;
